import { AnyAction, Reducer } from 'redux';

// export const STORE_MESSAGE_SUPPORT_PAGE_MESSAGE = 'data/send-support-message-data';
export const STORE_MESSAGETYPE_SUPPORT_PAGE = 'store/support-page-messagetype';
export const STORE_MESSAGE_SUPPORT_PAGE_MESSAGE = 'store/support-page-messages';
export const STORE_CASENO_SUPPORT_PAGE = 'store/support-page-caseno';
export const STORE_REFMESSAGEID_SUPPORT_PAGE = 'store/support-page-refmessageid';
export const STORE_GETSUPPORTMESSAGES = 'store/support-page-getMessage';
export const STORE_FILES_SUPPORTMSGATTACHMENT = 'store/support-page-attachment';
export const STORE_FILES_GETSUPPORTATTACHMENT = 'data/file-getsupportattachement';
export const STORE_SUPPORT_STATUSTYPE = 'data/chat-status-type';

export interface SupportAttachementData {
    // status: string;
    // message: string;
    // data: string;
    attachmentname: string;
    attachfilename: string;
}

export interface GetSupportMessage {
    rowno: string;
    messageid: string;
    mfrom: string;
    mdate: string;
    message: string;
    attachmentname: string;
    attachfilename: string;
    createdon: string;
    messageattachmentsrow: string;
    oci_status: string;
}

export interface NewSupportPage {
    messagetype: string;
    message: string;
    caseno: string;
    refmessageid: string;
}

export interface SupportPageState {
    newSupport?: NewSupportPage;
    getSupportMessage?: GetSupportMessage[];
    getSupportAttachmentData?: SupportAttachementData[];
    messagetype?: string;
    message?: string;
    caseno?: string;
    refmessageid?: string;
    messageFiles: Array<File>;
    statustype: string;
}

const initialState: SupportPageState = {
    newSupport: {
        messagetype: '',
        message: '',
        caseno: '',
        refmessageid: '',
    },
    getSupportMessage: [],
    messageFiles: [],
    getSupportAttachmentData: [],
    statustype: ''
};

const reducer: Reducer<SupportPageState> = (state: SupportPageState = initialState, action: AnyAction): SupportPageState => {
    switch (action.type) {
        case STORE_MESSAGETYPE_SUPPORT_PAGE:
            return {
                ...state,
                messagetype: action.messagetype
            };
        case STORE_MESSAGE_SUPPORT_PAGE_MESSAGE:
            return {
                ...state,
                message: action.message
            };
        case STORE_CASENO_SUPPORT_PAGE:
            return {
                ...state,
                caseno: action.caseno
            };
        case STORE_REFMESSAGEID_SUPPORT_PAGE:
            return {
                ...state,
                refmessageid: action.refmessageid
            };
        case STORE_GETSUPPORTMESSAGES:
            return {
                ...state,
                getSupportMessage: action.getSupportMessage
            };
        case STORE_FILES_SUPPORTMSGATTACHMENT:
            return {
                ...state,
                messageFiles: action.messageFiles
            };
        case STORE_FILES_GETSUPPORTATTACHMENT:
            return {
                ...state,
                getSupportAttachmentData: action.getSupportAttachmentData
            };
        case STORE_SUPPORT_STATUSTYPE:
            return {
                ...state,
                statustype: action.statustype
            };
        default:
            return state;
    }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/supportPage.tsx